import { render, staticRenderFns } from "./SwipeableCards.vue?vue&type=template&id=10a4b859&scoped=true"
import script from "./SwipeableCards.vue?vue&type=script&lang=js"
export * from "./SwipeableCards.vue?vue&type=script&lang=js"
import style0 from "./SwipeableCards.vue?vue&type=style&index=0&id=10a4b859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4b859",
  null
  
)

export default component.exports